import { render, staticRenderFns } from "./Header-Wx.vue?vue&type=template&id=55e0026e&scoped=true&"
import script from "./Header-Wx.vue?vue&type=script&lang=js&"
export * from "./Header-Wx.vue?vue&type=script&lang=js&"
import style0 from "./Header-Wx.vue?vue&type=style&index=0&id=55e0026e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e0026e",
  null
  
)

export default component.exports